module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teamcard"
  }, [_c('h1', {
    staticClass: "teamcard__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('Accordion', {
    attrs: {
      "opened": _vm.opened
    }
  }, [_c('div', {
    staticClass: "teamcard__mentors"
  }, [_c('MentoringTeamCardMentor', _vm._b({
    attrs: {
      "type": "curator"
    }
  }, 'MentoringTeamCardMentor', _vm.curator, false)), _c('MentoringTeamCardMentor', _vm._b({
    attrs: {
      "type": "mentor"
    }
  }, 'MentoringTeamCardMentor', _vm.mentor, false))], 1), _c('MentoringCrew', {
    attrs: {
      "child": _vm.child,
      "crew": _vm.crew
    }
  })], 1), _c('MentoringCardFooter', {
    attrs: {
      "text": _vm.buttonText
    },
    on: {
      "toggleDescription": _vm.toggle
    }
  }, [_c('MentoringFooterItem', {
    attrs: {
      "slot": "firstColumn",
      "icon": "user"
    },
    slot: "firstColumn"
  }, [_vm._v(_vm._s(_vm.footerUserCountText))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666466cc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/teamcard/MentoringTeamCard.vue
// module id = 6867d228f6d0c06c8f79
// module chunks = 89